import { render } from "./Part_Footer.vue?vue&type=template&id=0ee49cd8&scoped=true"
import script from "./Part_Footer.vue?vue&type=script&lang=js"
export * from "./Part_Footer.vue?vue&type=script&lang=js"

import "./Part_Footer.vue?vue&type=style&index=0&id=0ee49cd8&scoped=true&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\vue\\portfolio-test\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ee49cd8"]])

export default __exports__